class DocumentationStandarViewPaginator {

    constructor() {

        this._standarViewDocumentsTemplate = null;
        this._standarViewFoldersTemplate = null;
        this._standarViewDocumentsData = new StandarViewDocumentsData();

        this._loadTemplates();

    }

    _loadTemplates() {
        this._standarViewDocumentsTemplate = Handlebars.compile($("#documentationStandarViewDocuments").html());
        this._standarViewFoldersTemplate = Handlebars.compile($("#documentationStandarViewFolders").html());
    }

    _drawFoldersList() {

        const folder = this._standarViewDocumentsData.getFolder();
        const context = this._standarViewDocumentsData.getContext();

        _.forEach(folder.folders, function(currentFolder, index) {
            currentFolder.index =  index;
        });

        context.folders = folder.folders;
        baseController.stackSimpleContent(documentationScreenController.template, context);

        const $documentationList = $(".documentation-folders-" + folder.id);

        $documentationList.html(this._standarViewFoldersTemplate(context));

        documentationScreenController.setFolderNameEllipsis(folder);
        documentationScreenController.setStandarViewEvents();
        documentationScreenController.documentationGoUp.setButtonStyle(folder.id);
        documentationScreenController.documentationGoUp.setButtonPosition(folder.id, true);
        documentationScreenController.documentationNew.setButtonPosition(folder.id, true);
        documentationScreenController.documentationFilters.filtersManagement(folder.id);

        this._manageFoldersPagination();

    }

    drawMoreFolders(folder) {

        const context = this._standarViewDocumentsData.getContext();
        const lastFolderIndex = parseInt($(documentationScreenController.screen).find(".documentation-folders-link").last().attr("data-folder-index"));

        _.forEach(folder.folders, function(currentFolder, index) {
            currentFolder.index =  lastFolderIndex + index + 1;
        });

        context.folders = folder.folders;

        const $documentationList = $(".documentation-folders-" + folder.id);

        $documentationList.append(this._standarViewFoldersTemplate(context));
        documentationScreenController.setStandarViewEvents();

    }

    _drawDocumentsList() {

        const folder = this._standarViewDocumentsData.getFolder();
        const docs = documentationScreenController.getFolderDocuments(folder);

        documentationScreenController.sortDocumentElements(docs);
        documentationScreenController.setExtraDocumentsInfo(docs, folder);

        const context = this._standarViewDocumentsData.getContext();

        _.forEach(docs, function(doc, index) {
            doc.index = index;
        });

        context.documents = docs;

        baseController.stackSimpleContent(documentationScreenController.template, context);

        const $documentationList = $(documentationScreenController.screen).find("#documentation-documents");
        $documentationList.html(this._standarViewDocumentsTemplate(context));

        documentationScreenController.setDocumentsMargins(docs);
        documentationScreenController.setCarouselConfig(folder);
        documentationScreenController.setFolderNameEllipsis(folder);
        documentationScreenController.setStandarViewEvents();
        documentationScreenController.decorateElements();

        smartListsController.initialize();

        documentationScreenController.documentationGoUp.setButtonStyle(folder.id);
        documentationScreenController.documentationGoUp.setButtonPosition(folder.id, true);
        documentationScreenController.documentationNew.setButtonPosition(folder.id, true);
        documentationScreenController.documentationFilters.filtersManagement(folder.id);
        documentationScreenController.slideActionsDocumentList.initialize();

        this._manageDocumentsPagination();

    }

    drawMoreDocuments(folder) {

        const docs = documentationScreenController.getFolderDocuments(folder);

        documentationScreenController.sortDocumentElements(docs);
        documentationScreenController.setExtraDocumentsInfo(docs, folder);

        const context = this._standarViewDocumentsData.getContext();
        const lastDocumentIndex = parseInt($(documentationScreenController.screen).find("#documentation-documents li").last().attr("row-data-index"));

        _.forEach(docs, function(doc, index) {
            doc.index =  lastDocumentIndex + index + 1;
        });

        context.documents = docs;

        const $documentationList = $(documentationScreenController.screen).find("#documentation-documents");

        $documentationList.append(this._standarViewDocumentsTemplate(context));

        documentationScreenController.setDocumentsMargins(docs);
        documentationScreenController.setCarouselConfig(folder);
        documentationScreenController.setStandarViewEvents();
        documentationScreenController.decorateElements();
        documentationScreenController.slideActionsDocumentList.initialize();

    }

    _manageFoldersPagination() {

        function removeEvents() {
            $containerScroll.off("wheel.getMoreFolders touchmove.getMoreFolders");
        }

        function getMoreFolders() {

            const folderId = folder.id;

            api.getFolderDocuments(folderId, pageNumber, documentationScreenController.documentationPageSize, function(response) {

                $loader.hide();
                pendingRequest = false;
                pageNumber += 1;

                folder.folders = _.concat(folder.folders, response.result.folders);

                that.drawMoreFolders(response.result);

            }, false);

        }

        function onScrollBottom() {

            const scrollHeight = $containerScroll[0].scrollHeight;
            const bodyHeight = $containerScroll[0].clientHeight;
            const currentScrollPosition = $(window).scrollTop();
            const distanceToBottom = 100;

            if (currentScrollPosition > lastScrollPosition && currentScrollPosition + bodyHeight >= scrollHeight - distanceToBottom) {

                if (!pendingRequest) {

                    $loader.show();
                    pendingRequest = true;
                    getMoreFolders();

                }

            }

            lastScrollPosition = currentScrollPosition;

        }

        const that = this;
        const folder = this._standarViewDocumentsData.getFolder();
        const $loader = $(documentationScreenController.screen).find(".documentation-paginator-loader");
        const $containerScroll = $("body");
        const $backButton = $(".documentation-folder-header-back-btn");
        let lastScrollPosition = 0;
        let pendingRequest = false;
        let pageNumber = $(documentationScreenController.screen).find(".documentation-folders-tile").length / documentationScreenController.documentationPageSize;

        removeEvents();

        $containerScroll.on("wheel.getMoreFolders touchmove.getMoreFolders", function() {

            const isDocumentationVisible = $(documentationScreenController.screen).is(":visible");
            const isFolder = $(documentationScreenController.screen).find("#documentation-documents").children().length === 0;
            const hasFoldersLeft = $(".documentation-folders-tile").length < folder.total_folder_children;

            if (isDocumentationVisible && isFolder && hasFoldersLeft) {
                onScrollBottom();
            }

        });

    }

    _manageDocumentsPagination() {

        function removeEvents() {
            $containerScroll.off("wheel.getMoreDocuments touchmove.getMoreDocuments");
        }

        function getMoreDocuments() {

            const folderId = folder.id;

            api.getFolderDocuments(folderId, pageNumber, documentationScreenController.documentationPageSize, function(response) {

                $loader.hide();
                pendingRequest = false;
                pageNumber += 1;

                folder.documents = _.concat(folder.documents, response.result.documents);

                that.drawMoreDocuments(response.result);

            }, false);

        }

        function onScrollBottom() {

            const scrollHeight = $containerScroll[0].scrollHeight;
            const bodyHeight = $containerScroll[0].clientHeight;
            const currentScrollPosition = $(window).scrollTop();
            const distanceToBottom = 100;

            if (currentScrollPosition > lastScrollPosition && currentScrollPosition + bodyHeight >= scrollHeight - distanceToBottom) {

                if (!pendingRequest) {

                    $loader.show();
                    pendingRequest = true;
                    getMoreDocuments();

                }

            }

            lastScrollPosition = currentScrollPosition;

        }

        const that = this;
        const folder = this._standarViewDocumentsData.getFolder();
        const $loader = $(documentationScreenController.screen).find(".documentation-paginator-loader");
        const $containerScroll = $("body");
        const $backButton = $(".documentation-folder-header-back-btn");
        const $changeModeViewButton = $(".toggle-advanced-view-mode");
        let lastScrollPosition = 0;
        let pendingRequest = false;
        let pageNumber = $(documentationScreenController.screen).find("#documentation-documents li").length / documentationScreenController.documentationPageSize;
        let scrollTimeout = null;

        removeEvents();

        $containerScroll.on("wheel.getMoreDocuments touchmove.getMoreDocuments", function() {

            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function(){
                documentationScreenController.scrollPosition = $(window).scrollTop();
            }, 100);

            documentationScreenController.scrollPosition = $(window).scrollTop();

            const isDocumentationVisible = $(documentationScreenController.screen).is(":visible");
            const isFolder = $(documentationScreenController.screen).find("#documentation-documents").children().length === 0;
            const hasDocumentsLeft = $(documentationScreenController.screen).find("#documentation-documents li").length < folder.total_document_children;

            if (isDocumentationVisible && !isFolder && hasDocumentsLeft) {
                onScrollBottom();
            }

        });

        $backButton.one("click", removeEvents);
        $changeModeViewButton.one("click", removeEvents);

    }

    initialize(folder, isRootFolder, difficultyTimesFormatted, difficultyPointsFormatted, documentTags) {

        this._standarViewDocumentsData.setFolder(folder);
        this._standarViewDocumentsData.setIsRootFolder(isRootFolder);
        this._standarViewDocumentsData.setDifficultyTimesFormatted(difficultyTimesFormatted);
        this._standarViewDocumentsData.setDifficultyPointsFormatted(difficultyPointsFormatted);
        this._standarViewDocumentsData.setDocumentTags(documentTags);

        if (folder.documents) {
            if ($(".documentation-documents-" + folder.id).length === 0) {
                this._drawDocumentsList();
            } else {
                this._manageDocumentsPagination();
            }
        }

        if (folder.folders) {
            if ($(".documentation-folders-" + folder.id).length === 0) {
                this._drawFoldersList();
            } else {
                this._manageFoldersPagination();
            }
        }

    }

}